// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'
require("firebase/firestore");
require("firebase/auth");
Vue.config.productionTip = false

let config = {
    apiKey: "AIzaSyANaoJDIXK-94MICiJmWdSowlNF2VrBKHM",
    authDomain: "snipper-010.firebaseapp.com",
    databaseURL: "https://snipper-010.firebaseio.com",
    projectId: "snipper-010",
    storageBucket: "snipper-010.appspot.com",
    messagingSenderId: "863369684354"
};
// firebase.initializeApp(config);

firebase.initializeApp(config);

export const Auth = firebase.auth()
export const firestore = firebase.firestore()
const settings = { /* your settings... */ timestampsInSnapshots: true };
firestore.settings(settings);

let app;
// instant redirect for app if user is not logged in
firebase.auth().onAuthStateChanged(function(user) {
  if (!app) {
    app = new Vue({
      el: '#app',
      template: '<App/>',
      components: { App },
      router,
    })
  }
});


// WEBPACK FOOTER //
// ./src/main.js